import { createAction } from '@reduxjs/toolkit';

type SavePaymentMethodDataParameter =
  | undefined
  | Record<string, unknown>
  | { key: Record<string, unknown> };

export const savePaymentMethodData =
  createAction<SavePaymentMethodDataParameter>(
    'payments/savePaymentMethodData',
  );
